<template>
  <span v-bind="$attrs">
    <v-icon :icon="icon" :size="size" :color="color" />
  </span>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import { IconStringWithModifiers } from "@/types/Icon"

  type IconSizes = "x-small" | "small" | "default" | "large" | "x-large"

  export default defineComponent({
    inheritAttrs: false,
    props: {
      icon: {
        type: String as PropType<IconStringWithModifiers>,
        default: "",
        required: true,
      },
      size: {
        type: String as PropType<IconSizes>,
        default: "default",
        required: false,
      },
      color: {
        type: String,
        default: "",
        required: false,
      },
    },
  })
</script>
